const iOsSmartApp = 'https://apps.apple.com/app/hp-smart/id469284907';
const macOsSmartApp = 'https://apps.apple.com/app/hp-smart/id1474276998';
const androidSmartApp =
  'https://play.google.com/store/apps/details?id=com.hp.printercontrol';
const microsoftSmartApp =
  'https://apps.microsoft.com/store/detail/hp-smart/9WZDNCRFHWLH?hl=en-us&gl=us';

const getMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent;

  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'iOS';
  }

  return 'unknown';
};

const getDesktopOperatingSystem = () => {
  if (navigator.userAgent.indexOf('Win') != -1) {
    return 'Windows OS';
  }
  if (navigator.userAgent.indexOf('Mac') != -1) {
    return 'Macintosh';
  }
  return 'unknown';
};

const isMobile = () => {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true;
  } else {
    return false;
  }
};

export const getSmartAppLink = (): string => {
  const isMobileDevice = isMobile();

  if (isMobileDevice) {
    const mobileOs = getMobileOperatingSystem();

    if (mobileOs === 'iOS') {
      return iOsSmartApp;
    } else if (mobileOs === 'Android') {
      return androidSmartApp;
    } else {
      return microsoftSmartApp;
    }
  } else {
    const desktopOs = getDesktopOperatingSystem();

    if (desktopOs === 'Macintosh') {
      return macOsSmartApp;
    } else if (desktopOs === 'Windows OS') {
      return microsoftSmartApp;
    }
  }

  // Default fallback
  return microsoftSmartApp;
};
